module.exports = __webpack_public_path__ + "img/menu-icon.58f94ca9.png";